const AssociateCardCount = ({
  count,
  text,
}: {
  count: number;
  text: string;
}) => {
  // rendering associate card count section here
  return (
    <div className='text-center [&:not(:last-child)]:border-r-2 border-base-cyan/55 py-1'>
      <h4 className='font-medium text-lg text-base-dark-green leading-none'>
        {count}
      </h4>
      <p className='text-xs font-medium text-legal-dark-blue'>{text}</p>
    </div>
  );
};

export default AssociateCardCount;
